import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.16667 4.20839C9.20834 4.00006 9.04167 3.75006 8.83334 3.75006L6.45834 3.41672L5.375 1.25006C5.33334 1.16672 5.29167 1.12506 5.20834 1.08339C5 0.958389 4.75 1.04172 4.625 1.25006L3.58334 3.41672L1.20834 3.75006C1.08334 3.75006 1 3.79172 0.958336 3.87506C0.791669 4.04172 0.791669 4.29172 0.958336 4.45839L2.66667 6.12506L2.25 8.50006C2.25 8.58339 2.25 8.66672 2.29167 8.75006C2.41667 8.95839 2.66667 9.04172 2.875 8.91672L5 7.79172L7.125 8.91672C7.16667 8.95839 7.25 8.95839 7.33334 8.95839C7.375 8.95839 7.375 8.95839 7.41667 8.95839C7.625 8.91672 7.79167 8.70839 7.75 8.45839L7.33334 6.08339L9.04167 4.41672C9.125 4.37506 9.16667 4.29172 9.16667 4.20839Z",
		fill: "white"
	})
});
export default SvgStar;
